<template>
  <div class="auth-wrapper">
    <div class="auth-inner">
      <form class="form" @submit.prevent="">
        <h1 class="title">Ildiz</h1>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label>Xonalar soni:</label>
            <select v-model="form.number_length" class="form-control">
              <option
                v-for="(number, index) in generateNumber(1, 7, 1)"
                :key="index"
                :value="number"
              >
                {{ number }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-12">
            <label>Misollar soni:</label>
            <input
              v-model="form.number_row"
              class="form-control"
              max="300"
              min="1"
              type="number"
              value="10"
            />
          </div>
        </div>

        <div class="text-center d-flex justify-content-around">
          <button
            class="btn btn-orange"
            type="submit"
            @click.prevent="submit(0)"
          >
            Excel fayl
          </button>
          <button
            class="btn btn-orange"
            type="submit"
            @click.prevent="submit(1)"
          >
            PDF fayl
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "settings",
  data: function () {
    return {
      form: {
        number_length: 3,
        number_row: 100,
      },
    };
  },
  computed: {
    header() {
      return [
        ["Ildiz"],
        [
          "Xonasi: " + this.form.number_length,
          "Qatori : " + this.form.number_row,
          "Jami: " + this.form.number_count,
        ],
      ];
    },
    generated_numbers() {
      return this.$store.getters["root/state"].generated_numbers;
    },
  },
  methods: {
    prepareAnswer(array) {
      let arr = [];
      let chunk = 5;
      let row = [];
      let table = [];
      array.map((value) => {
        arr.push(this.calcAnswer(value));
      });
      if (this.form.number_one_length + this.form.number_two_length <= 4) {
        chunk = 8;
      }
      if (
        this.form.number_one_length + this.form.number_two_length >= 5 &&
        this.form.number_one_length + this.form.number_two_length <= 7
      ) {
        chunk = 7;
      }
      if (
        this.form.number_one_length + this.form.number_two_length >= 8 &&
        this.form.number_one_length + this.form.number_two_length <= 10
      ) {
        chunk = 6;
      }
      if (this.form.number_one_length + this.form.number_two_length >= 10) {
        chunk = 4;
      }
      for (let i = 0; i < arr.length; i += chunk) {
        let sliced = arr.slice(i, i + chunk);
        row = [];
        for (let j = 0; j < sliced.length; j++) {
          row.push({
            text: i + 1 + j,
            style: "tableHeader",
          });
          row.push({
            text: arr[i + j],
          });
        }
        table.push({
          style: "table",
          table: {
            headerRows: 0,
            widths: this.filledArray(row.length, "*"),
            body: [row],
          },
          // layout: "headerLineOnly",
          layout: {
            hLineWidth: function () {
              return 1;
            },
            vLineWidth: function () {
              return 1;
            },
            hLineColor: function () {
              return "black";
            },
            vLineColor: function () {
              return "black";
            },
          },
        });
        table.push({ text: "", margin: [0, 4, 0, 4] });
      }
      return table;
    },
    calcAnswer: function (array) {
      return Math.sqrt(array);
    },
    prepare2PDF: function (data) {
      let table = [];
      let row = [];
      let chunk = 4;
      if (
        this.form.number_one_length + this.form.number_two_length >= 5 &&
        this.form.number_one_length + this.form.number_two_length <= 6
      ) {
        chunk = 3;
      }
      if (this.form.number_one_length + this.form.number_two_length >= 7) {
        chunk = 2;
      }
      for (let i = 0; i < data.length; i += chunk) {
        let sliced = data.slice(i, i + chunk);
        row = [];
        for (let j = 0; j < sliced.length; j++) {
          row.push({
            text: i + 1 + j,
            style: "tableHeader",
          });
          row.push({
            text: "√" + sliced[j],
            decoration: "overline",
          });
          row.push({
            text: "=",
          });
          row.push({
            text: "        ",
            style: "tableFooter",
          });
        }
        table.push({
          style: "table",
          table: {
            headerRows: 0,
            widths: this.filledArray(row.length, "*"),
            body: [row],
          },
          // layout: "headerLineOnly",
          layout: {
            hLineWidth: function () {
              return 1;
            },
            vLineWidth: function () {
              return 1;
            },
            hLineColor: function () {
              return "black";
            },
            vLineColor: function () {
              return "black";
            },
          },
        });
        table.push({ text: "", margin: [0, 4, 0, 4] });
      }
      return table;
    },
    filledArray: function (index, char = " ") {
      let arr = [];
      for (let i = 0; i < index; i++) {
        if (i % 2 === 0) {
          arr.push("auto");
        } else {
          arr.push(char);
        }
      }
      return arr;
    },
    styledArray: function (
      index,
      char = " ",
      isFirstNumber = false,
      number = 0
    ) {
      let arr = [];
      for (let i = 0; i < index; i++) {
        if (char === " ") {
          if (isFirstNumber && i === 0) {
            arr.push({ text: "№", style: "tableHeader" });
          } else if (isFirstNumber) {
            arr.push({ text: i + number, style: "tableHeader" });
          } else {
            arr.push({ text: i + 1, style: "tableHeader" });
          }
        } else {
          if (i === 0) {
            arr.push({ text: "=", style: "tableFooter" });
          } else {
            arr.push({ text: char, style: "tableFooter" });
          }
        }
      }
      return arr;
    },
    rotate: function (data) {
      let numbers = data;
      const transpose = (matrix) => {
        let [row] = matrix;
        return row.map((value, column) => matrix.map((row) => row[column]));
      };
      return transpose(numbers);
    },
    submit: async function (number) {
      if (await this.$store.dispatch("root/generate", this.form)) {
        if (number === 0) {
          await this.doExcel(this.generated_numbers);
        }
        if (number === 1) {
          await this.makePdf(this.generated_numbers);
        }
      }
    },
    async makePdf(data) {
      let tables = this.prepare2PDF(data);
      let table_answer = this.prepareAnswer(data);

      let docDefinition = {
        info: {
          title: "Orange Academy",
          author: "Olimjon Gofurov",
        },
        pageSize: "A4",
        // pageOrientation: "landscape",
        pageMargins: [20, 10, 20, 10],
        content: [
          {
            columns: [
              {
                image: "logo",
                fit: [50, 50],
                width: "15%",
                margin: [20, 0, 20, 10],
              },
              {
                text: "Misollar soni: __________\t To'g'ri javob: __________\t Vaqti: __________",
                width: "85%",
                // alignment: "left",
                margin: [0, 20, 0, 0],
              },
            ],
          },
          ...tables,
          {
            text: "Javoblari",
            style: "header",
            pageBreak: "before",
          },
          ...table_answer,
        ],
        styles: {
          defaultStyle: {
            fontSize: 12,
          },
          header: {
            fontSize: 14,
            bold: true,
            alignment: "center",
            // margin: [0, 20, 0, 0],
          },
          table: {
            alignment: "center",
            // margin: [0, 0, 0, 0],
          },
          tableHeader: {
            bold: true,
            // margin: [0, 4, 0, 4],
            border: [false, false, false, false],
            fillColor: "orangered",
          },
          tableFooter: {
            bold: true,
            border: [true, true, true, true],
            fontSize: 22,
            fillColor: "#eee",
          },
        },
        images: {
          logo: "data:image/png;base64,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",
        },
      };
      console.log(docDefinition);
      // await pdfMake.createPdf(docDefinition).open();
      await pdfMake.createPdf(docDefinition).download("OrangeAcademy");
    },
    generateNumber: function (begin, end, step = 1) {
      let numbers = [];
      for (let i = begin; i <= end; i += step) {
        numbers.push(i);
      }
      return numbers;
    },
    async doExcel(data) {
      let worksheet1 = XLSX.utils.aoa_to_sheet([]);
      let worksheet2 = XLSX.utils.aoa_to_sheet([]);
      let row = -1;
      let column = -1;
      let chunk = 10;
      for (let i = 0; i < data.length; i += chunk) {
        let sliced = data.slice(i, i + chunk);
        column++;
        for (let j = 0; j < sliced.length; j++) {
          row++;
          await XLSX.utils.sheet_add_aoa(worksheet1, [["√" + sliced[j]]], {
            origin: { r: row, c: column },
          });
          await XLSX.utils.sheet_add_aoa(worksheet2, [["√" + sliced[j]]], {
            origin: { r: row, c: column },
          });
          column++;
          await XLSX.utils.sheet_add_aoa(
            worksheet2,
            [["= " + Math.sqrt(sliced[j])]],
            {
              origin: { r: row, c: column },
            }
          );
          column--;
        }
        column += 2;
        row = -1;
      }
      let new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet1, "Misollar");
      XLSX.utils.book_append_sheet(new_workbook, worksheet2, "Javoblar");
      XLSX.writeFile(new_workbook, "Arifmetika.xlsx");
    },
  },
  mounted() {},
};
</script>
